export default {
  RES_PERCENT: 'RES_PERCENT',
};
